import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import api from "../../api/api";
import { setAuth } from "../../utils/auth";
import "bootstrap/dist/css/bootstrap.min.css";
import { RECAPTCHA_SITE_KEY, GOOGLE_AUTH_URL } from "../../config";

function generateCode() {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let code = "";
  for (let i = 0; i < 5; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
}

export default function ExternalUserLogin() {
  const navigate = useNavigate();
  const location = useLocation();

  const [form, setForm] = useState({
    identifier: "",
    password: ""
  });

  const [challenge, setChallenge] = useState("");
  const [userInput, setUserInput] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setChallenge(generateCode());
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleGoogleLogin = () => {
    window.location.href = GOOGLE_AUTH_URL;
  };

  const refreshCode = () => {
    setChallenge(generateCode());
    setUserInput("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🔴 SIMPLE MATCH CHECK
    if (userInput.toUpperCase() !== challenge) {
      setError("Verification code does not match");
      refreshCode();
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await api.post("/api/public/auth/login", {
        identifier: form.identifier,
        password: form.password
      });

      setAuth(res.data.token, null, res.data.role);

      const redirectTo = location.state?.from || "/user-dashboard";
      navigate(redirectTo);

    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
      refreshCode();
    }
  };

 return (
  <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light">
    
    <div
      className="shadow-lg rounded-4 bg-white p-4"
      style={{ maxWidth: "450px", width: "100%" }}
    >
      <h3 className="text-center mb-2">Welcome Back</h3>
      <p className="text-center text-muted mb-4">
        Login to access your Orgavitaz account
      </p>

      <form onSubmit={handleSubmit}>
        {/* Email / Phone */}
        <div className="mb-3">
          <label>Email or Mobile</label>
          <input
            type="text"
            name="identifier"
            className="form-control"
            placeholder="Enter email or mobile"
            value={form.identifier}
            onChange={handleChange}
            required
          />
        </div>

        {/* Password */}
        <div className="mb-3">
          <label>Password</label>
          <input
            type="password"
            name="password"
            className="form-control"
            placeholder="Enter password"
            value={form.password}
            onChange={handleChange}
            required
          />
        </div>

        <div className="d-flex justify-content-end mb-3">
          <Link to="/forgot-password" className="text-decoration-none">
            Forgot password?
          </Link>
        </div>

        {/* CAPTCHA */}
         <div className="mb-3">
            <label className="fw-bold">Enter the code below</label>

            <div className="d-flex align-items-center gap-2 mb-2">
              <div
                className="px-3 py-2 border rounded bg-light fw-bold"
                style={{ letterSpacing: "3px", fontSize: "18px" }}
              >
                {challenge}
              </div>

              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={refreshCode}
              >
                ↻
              </button>
            </div>

            <input
              className="form-control"
              placeholder="Enter code"
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              required
            />
          </div>

            {error && <div className="alert alert-danger">{error}</div>}

        <button
          type="submit"
          className="btn btn-success w-100 mb-3"
          disabled={loading}
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>

      <p className="text-center">
        Don’t have an account?{" "}
        <Link to="/register">Register</Link>
      </p>

      <div className="text-center my-2 text-muted">or</div>

      <button
        className="btn btn-outline-danger w-100"
        onClick={handleGoogleLogin}
      >
        <i className="bi bi-google me-2"></i>
        Continue with Google
      </button>
    </div>
  </div>
);
}